/***
 * Created on 2023/8/29
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useRef, useState} from 'react';
import ModalDialog from "../../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@tanstack/react-query";
import {apiGet, apiPost} from "../../../../../../service/api";
import {useTogglePopup} from "../../../../../../hook/toggle_popup";


function AddPhoneStep1({show=false, closeWizard, metadata, next}) {
    const { t } = useTranslation();
    const modalRef = useRef();
    const {isShow, toggleAction, elemRef} = useTogglePopup();
    const [country, setCountry] = useState();

    const country_code = useQuery({
        queryKey: ['get_country_code'],
        queryFn: async () => await apiGet('/ajax/country_code')
    });

    const sendSMSCode = useMutation({
        mutationFn: async (data) => await apiPost('/ajax/send_sms_code', data),
        onSuccess: data => {
            // setNextIndex(prev => prev + 1);
            metadata.setSeconds(metadata.seconds);
            next();
        },
        onError: (error, variables, context) => {
            console.error(error);
        }
    });

    const onSelectCountry = (country) => {
        metadata.setValues(prev => {
            return {
                ...prev,
                country_code: `+${country.country_code}`
            }
        });
        setCountry(country);
    }

    const onSend = async () => {
        await sendSMSCode.mutateAsync({
            country_code: country.country_code,
            phone: metadata.values.phone,
            send_type: metadata.values.send_type,
            event_type: metadata.values.event_type
        });
    }

    return (
        <ModalDialog title={t('@Add phone number@')} showModal={show} closeModal={closeWizard} hideSubmit={true} ref={modalRef}>
            <div className="dialog-content">
                <div className="dialog__form-group">
                    <label>{t('@myQNAPcloud will send a verification code to this phone whenever you sign in from an untrusted device.@')}</label>
                    <div className="comp-input">
                        <div className="input-field--hybrid">
                            <div className={`comp-select ${isShow ? 'active' : ''}`} ref={elemRef} onClick={toggleAction}>
                                <div className="q-select cursor-pointer">
                                    <div className="q-select__label">{country?.country}({country?.country_code})</div>
                                    <div className="q-select__arrow"></div>
                                </div>
                                <div className="comp-dropdown" data-modal-sheet>
                                    <ul className="dropdown-menu">
                                        <li className="dropdown-menu-section">
                                            {
                                                country_code?.data && country_code.data.map(country =>
                                                    <div className="dropdown-menu__item cursor-pointer" key={country._id} onClick={()=>onSelectCountry(country)}>{country.country}(+{country.country_code})</div>
                                                )
                                            }
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <input type="text" className="" name="phone" required pattern="\d*" minLength={6} value={metadata.values.phone} onChange={metadata.onChange}/>
                            <button className="q-btn q-btn-default" disabled={metadata.seconds > 0 || !metadata?.values?.phone} onClick={onSend}>
                                {metadata.seconds <= 0 ? t('@Send@') : `${t('@Resend me a code@')} (${metadata.seconds})`}
                            </button>
                        </div>
                    </div>
                </div>
                {/*<p className="text-error">Error message</p>*/}
                <ol className="list-style-type-disc ml-16">
                    <li><span className="text-note">{t('@Message and date rates may apply.@')}</span></li>
                    <li><span className="text-note">{t('@Delivery speed and availability may vary by location and service provider.@')}</span></li>
                    <li><span className="text-note">{t('@If you received multiple verification codes, only the newest one will work.@')}</span></li>
                </ol>
            </div>
        </ModalDialog>
    );
}

export default AddPhoneStep1;